import * as requestFromServer from "./staffApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import { getUserProfileAction } from "../auth/authServices";

// staff -> get staff api
export const getStaffAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getStaff(dataToBeSent);
  if (response) {
    setLoading(false);
    dispatch(
      Actions.createAction(Actions.GET_STAFFS_LIST, { staffs: response })
    );
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// staff -> get staff select list api
export const getStaffSelectListAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getStaffSelectList(dataToBeSent);
  if (response) {
    setLoading(false);
    dispatch(
      Actions.createAction(Actions.GET_STAFFS_SELECT_LIST, { staffs: response })
    );
    dispatch(Actions.createAction(Actions.GET_STAFFS_SELECT_LIST_FOR_REQUESTS, {staffs: response}));
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// staff -> create staff api
export const createStaffAction =
  (dataToBeSent, navigate, setLoading, setUserSession) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createStaff(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      /* setting the user session based on roles */
      dispatch(getUserProfileAction(setUserSession)).then(() => {
        navigate(baseRouteMaker(routes.STAFF));
      });
      /* setting the user session based on roles */
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// staff -> update staff api
export const updateStaffAction =
  (dataToBeSent, navigate, setLoading, setUserSession) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateStaff(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);

      /* setting the user session based on roles */
      dispatch(getUserProfileAction(setUserSession)).then(() => {
        navigate(baseRouteMaker(routes.STAFF));
      });
      /* setting the user session based on roles */
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// staff -> get staff by id api
export const getStaffByIdAction =
  (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getStaffById(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// staff -> delete staff by id api
export const deleteStaffByIdAction =
  (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.deleteStaffById(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };


  // api -> create payment intent
export const renewStaffAction =
(
  dataToBeSent,
  setLoading,
  setOpenPaymentConfirmationDialog,
  resetDefaultFields
) =>
async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.renewStaff(dataToBeSent);
  if (response) {
    setLoading(false);
    dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
    dispatch(
      Actions.createAction(Actions.GET_VALIDATE_COUPON, {
        validateCouponData: {},
      })
    );
    setOpenPaymentConfirmationDialog(true);
    resetDefaultFields();
    return response;
  } else {
    setLoading(false);
    return null;
  }
};